import { render, staticRenderFns } from "./ReceivingOrder.vue?vue&type=template&id=160fa23f&"
import script from "./ReceivingOrder.vue?vue&type=script&lang=js&"
export * from "./ReceivingOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingOrder.vue?vue&type=style&index=0&id=160fa23f&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160fa23f')) {
      api.createRecord('160fa23f', component.options)
    } else {
      api.reload('160fa23f', component.options)
    }
    module.hot.accept("./ReceivingOrder.vue?vue&type=template&id=160fa23f&", function () {
      api.rerender('160fa23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/ReceivingOrder.vue"
export default component.exports